import Swiper from 'swiper';
import { Pagination, EffectFade, Autoplay } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';

export class SectionProduct {
	constructor(selector) {
		this.$container = selector;

		if (!this.$container) return;

		this.init();
	}

	init() {
		this.$sliderContainer = this.$container.querySelector('.swiper');

		if (this.$sliderContainer) {
			new Swiper(this.$sliderContainer, {
				modules: [Pagination, EffectFade, Autoplay],
				slidesPerView: 1,
				spaceBetween: 0,
				rewind: true,
				effect: 'fade',
				fadeEffect: {
					crossFade: true,
				},
				autoplay: {
					delay: 5000,
					disableOnInteraction: false,
					pauseOnMouseEnter: true,
				},
				pagination: {
					el: this.$container.querySelector('.js-swiper-pagination'),
					clickable: true,
				},
			});
		}
	}
}
